import type { TournamentStatus } from "@/lib/api";
import { Badge } from "@/components/ui/Badge";

const LABELS: Record<TournamentStatus, string> = {
  DRAFT: "Bozza",
  TEXTS_GENERATED: "Testi generati",
  TEXTS_APPROVED: "Testi approvati",
  FLYER_GENERATED: "Locandina generata",
  FLYER_APPROVED: "Locandina approvata",
  EMAIL_COMPOSED: "Email pronta",
  EMAILS_SENT: "Email inviate",
  LANDING_DEPLOYED: "Landing online",
  WHATSAPP_SENT: "WhatsApp inviato",
  SOCIAL_RUNNING: "Social attivo",
  COMPLETED: "Completato",
  FAILED: "Errore",
};

const VARIANTS: Record<
  TournamentStatus,
  "neutral" | "info" | "success" | "warning" | "danger" | "primary" | "court"
> = {
  DRAFT: "neutral",
  TEXTS_GENERATED: "info",
  TEXTS_APPROVED: "info",
  FLYER_GENERATED: "info",
  FLYER_APPROVED: "court",
  EMAIL_COMPOSED: "court",
  EMAILS_SENT: "primary",
  LANDING_DEPLOYED: "primary",
  WHATSAPP_SENT: "primary",
  SOCIAL_RUNNING: "success",
  COMPLETED: "success",
  FAILED: "danger",
};

export function StatusBadge({
  status,
  dot = true,
}: {
  status: TournamentStatus | string;
  dot?: boolean;
}) {
  // Normalizza uppercase (il backend può ritornare lowercase)
  const upper =
    typeof status === "string" ? (status.toUpperCase() as TournamentStatus) : "DRAFT";
  const key = upper in LABELS ? upper : "DRAFT";
  return (
    <Badge variant={VARIANTS[key]} dot={dot}>
      {LABELS[key]}
    </Badge>
  );
}
